module.exports = __webpack_public_path__ + "img/my_service.62e6a23.svg";